@if (!loading && hospital) {
  <app-breadcrumb
    listado="/main/emergencias/hospitales"
    etiquetaListado="Hospitales"
    [titulo]="hospital?.identificacion"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas del detalle -->
  <header class="encabezado">
    <div class="encabezado-avatar"><mat-icon>local_hospital</mat-icon></div>
    <div class="encabezado-texto">
      <h1>{{ hospital.identificacion || 'Hospital' }}</h1>
      <div class="encabezado-chips">
        @if (hospital.valores?.activo) {
          <span class="chip estado-ok">Activo</span>
        } @else {
          <span class="chip">Inactivo</span>
        }
        @if (hospital.valores?.gestion) {
          <span class="chip">
            <mat-icon>category</mat-icon>
            Gestión {{ hospital.valores.gestion.toLowerCase() }}
          </span>
        }
        @if (cliente) {
          <span class="chip">
            <mat-icon>business</mat-icon>
            {{ cliente }}
          </span>
        }
      </div>
    </div>
    @if (puedeEditar) {
      <button
        irxBotonIcono
        class="encabezado-editar"
        (click)="editar()"
        tooltip="Editar hospital"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
  </header>

  <!-- Una sola vista: sin pestañas -->
  <div class="detalle-cuerpo">
    <div class="em-grilla">
      <app-dt-card titulo="Datos" icono="local_hospital">
        <app-dt-datos>
          <app-dt-dato
            etiqueta="Teléfono"
            [valor]="hospital.valores?.telefono"
            copiable
          />
          <app-dt-dato
            etiqueta="Email"
            [valor]="hospital.valores?.email"
            copiable
          />
          <app-dt-dato etiqueta="Dirección" [valor]="hospital.direccion" />
          <app-dt-dato etiqueta="Fecha de alta" [valor]="fechaAlta" />
        </app-dt-datos>
      </app-dt-card>

      @if (mapCardConfig) {
        <app-map-card [config]="mapCardConfig" height="440px"></app-map-card>
      } @else {
        <app-dt-card titulo="Ubicación" icono="location_on">
          <span class="dt-muted">
            Sin ubicación cargada. Editá el hospital para ubicarlo en el mapa.
          </span>
        </app-dt-card>
      }
    </div>
  </div>
} @else if (!loading) {
  <app-breadcrumb
    listado="/main/emergencias/hospitales"
    etiquetaListado="Hospitales"
    [titulo]="hospital?.identificacion"
  ></app-breadcrumb>
  <app-empty-state
    icon="local_hospital"
    message="No se encontró el hospital"
  ></app-empty-state>
} @else {
  <app-detalle-esqueleto
    icono="local_hospital"
    listado="/main/emergencias/hospitales"
    etiquetaListado="Hospitales"
    [pestanas]="0"
  ></app-detalle-esqueleto>
}
